import { render, staticRenderFns } from "./TripAdvisorIcon.vue?vue&type=template&id=f9ed9520"
import script from "./TripAdvisorIcon.vue?vue&type=script&lang=js"
export * from "./TripAdvisorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports